import { z } from 'zod';
import { uuidSchema } from './common';

/**
 * L'identifiant d'appareil est engendré par le client et conservé en stockage
 * local : c'est lui qui distingue les téléphones d'un même compte.
 */
export const credentialsSchema = z.object({
  email: z.string().trim().toLowerCase().email('Adresse électronique invalide'),
  password: z.string().min(10, 'Au moins 10 caractères'),
  deviceId: uuidSchema,
  deviceName: z.string().trim().min(1, 'Nom d’appareil obligatoire').max(60),
});

export type Credentials = z.infer<typeof credentialsSchema>;

export const deviceRenameSchema = z.object({
  name: z.string().trim().min(1).max(60),
});

export interface SessionUser {
  id: string;
  email: string;
}

export interface SessionDevice {
  id: string;
  name: string;
}

export interface SettingsPayload {
  cycleStartDay: number;
  primaryAccountId: string | null;
}

export interface SessionResponse {
  accessToken: string;
  expiresInSeconds: number;
  user: SessionUser;
  device: SessionDevice;
  settings: SettingsPayload;
}

/** Dit à l'interface s'il faut proposer la création du compte ou la connexion. */
export interface AuthStatusResponse {
  bootstrapped: boolean;
}

export const settingsUpdateSchema = z.object({
  cycleStartDay: z.number().int().min(1).max(28).optional(),
  primaryAccountId: uuidSchema.nullable().optional(),
});
